import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../store';

interface IUserSlice {
  clientId: string | null;
}

const initialState: IUserSlice = {
  clientId: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    changeUserSelected: (state, action: PayloadAction<any>) => {
      state.clientId = action.payload;
    },
  },
});

export const { changeUserSelected } = userSlice.actions;

export const userSelector = (state: RootState) => state.user;

export default userSlice.reducer;
